import React, { useMemo } from 'react'

import Head from '../../head'

import { Carousel } from '@cms/ui'
import { cleanUrl } from '@cms/utils'

const height = 400;

const Page = (props) => {
  const images = useMemo(() => {
    if (!props.data) return null;

    const { en_name, thumbnail, photos } = props.data || {};

    const parseFn = (obj, i) => ({
        src: `${process.env.NEXT_IMAGE_ENDPOINT}/${obj.hash}`,
        alt: `Image ${i + 1} for "${en_name}"`,
        ratio: obj.ratio,
        sizes: `${obj.ratio * height}px`,
        placeholder: obj.responsiveImages.placeholder
    })

    return [thumbnail, ...photos].filter(Boolean).map(parseFn);
  }, [props.data]);

  if (!props.data) return null

  const { zh_name, en_name, thumbnail, content } = props.data || {};

  const desc = `"${en_name}", Chan Kwan-Lok's publications, also named "${zh_name}".`


  return (
    <>
      <Head
        title={`${en_name} | ${zh_name}`}
        desc={desc}
        img={`${process.env.NEXT_IMAGE_ENDPOINT}/${thumbnail.hash}`}
        ogTitle={`${en_name} | ${zh_name}`}
      />
      <div className="row publication-page">
        <div className="column">
          <Carousel
            height={height}
            images={images}
          />
        </div>

        <div className="column">
          <h3>{zh_name}</h3>
          <h1>{en_name}</h1>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </>
  )
}

export default Page

export async function getStaticProps({ params, preview = false }) {
  const { parseData, fetchPublication } = await import('../../data')

  const data = parseData(await fetchPublication(params.slug), 'publications')

  const marked = await import('marked')

  return {
    props: {
      preview,
      data: {
        ...data,
        content: marked.parse(data.content),
      },
    }
  }
}

export async function getStaticPaths() {
  const { fetchPublications } = await import('../../data')

  const slugs = await fetchPublications()

  return {
    paths: slugs.map((id) => ({
      params: {
        slug: String(id),
      },
    })),
    fallback: false,
  }
}
